import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { Collapse } from "bootstrap";
import Logo from "./images/FINAL-LOGO-GV.png";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);
  const location = useLocation();
  const collapseInstance = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    // Initialize Bootstrap collapse
    const navCollapse = document.getElementById("navbarNav");
    if (navCollapse) {
      collapseInstance.current = new Collapse(navCollapse, {
        toggle: false,
      });
    }

    return () => {
      if (collapseInstance.current) {
        collapseInstance.current.dispose();
        collapseInstance.current = null;
      }
    };
  }, []);

  const toggleNavbar = () => {
    const navCollapse = document.getElementById("navbarNav");
    if (navCollapse) {
      const bsCollapse = Collapse.getInstance(navCollapse) || new Collapse(navCollapse, { 
        toggle: false,
        parent: null
      });
      bsCollapse.toggle();
      setIsNavCollapsed(!isNavCollapsed);
    }
  };

  const closeNavbar = () => {
    const navCollapse = document.getElementById("navbarNav");
    if (navCollapse && !isNavCollapsed) {
      const bsCollapse = Collapse.getInstance(navCollapse);
      if (bsCollapse) {
        bsCollapse.hide();
        setIsNavCollapsed(true);
      }
    }
  };

  const navLinks = [
    { path: "/", label: "Home" },
    { path: "/about", label: "About Us" },
    { path: "/services", label: "Services" },
    // { path: "/blog", label: "Blog" },  
    // { path: "/career", label: "Career" },
    { path: "/contact", label: "Contact" },
  ];

  return (
    <div className="navbar-main">
      <nav
        className={`navbar navbar-expand-lg fixed-top ${isScrolled ? "scrolled" : ""
          }`}
      >
        <div className="container">
          <Link to="/" className="navbar-brand" aria-label="GrowthVibe Home">
            <img
              src={Logo}
              alt="GrowthVibe logo"
              height={60}
              width={180}
              loading="eager"
              style={{
                maxHeight: '60px',
                maxWidth: '180px',
                width: 'auto',
                height: 'auto',
                objectFit: 'contain'
              }}
            />
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            onClick={toggleNavbar}
            aria-expanded={!isNavCollapsed}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className={`collapse navbar-collapse`} id="navbarNav">
            <ul className="navbar-nav ms-auto">
              {navLinks.map((link) => (
                <li className="nav-item" key={link.path}>
                  <Link
                    className={`nav-link ${location.pathname === link.path ? "active" : ""
                      }`}
                    to={link.path}
                    onClick={closeNavbar}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="d-flex ms-lg-3">
              <Link
                to="/contact"
                className="btn btn-primary"
                onClick={closeNavbar}
              >
                Get Started
              </Link>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
